export default [
    // { name: 'Home', href: '/' },
    // { name: 'Item 1', href: 'https://example.com', target: "_blank" }
]